import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, ZapIcon, DownloadIcon, InfinityIcon, CheckCircle2 } from 'lucide-react';
export const PricingSection = memo(function PricingSection() {
  const CHECKOUT_URL = 'https://checkout.construyeprogreso.com/cart/48165248860330:1';
  return <section id="compra" className="py-14 px-4 bg-gray-900 scroll-mt-20 border-t border-gray-800 relative overflow-hidden" data-id="element-111">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-blue-500/5 rounded-full blur-3xl pointer-events-none" data-id="element-112" />

      <div className="max-w-xl mx-auto relative z-10" data-id="element-113">
        {/* Headline */}
        <div className="text-center mb-8" data-id="element-114">
          <h2 className="text-2xl md:text-4xl font-black text-white leading-tight mb-2" data-id="element-115">
            Dejá de tirar plata en técnicos.{' '}
            <span className="text-blue-500" data-id="element-116">Resolvelo vos mismo.</span>
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-117">
            Con el{' '}
            <span className="text-white font-bold" data-id="element-118">
              Megapack Electricista en Casa
            </span>{' '}
            eso se termina hoy.
          </p>
        </div>

        {/* Card */}
        <div className="bg-gray-800/80 backdrop-blur-sm rounded-2xl border border-gray-700 shadow-2xl overflow-hidden" data-id="element-119">
          {/* Banner urgencia */}
          <div className="bg-red-600 text-white text-center py-2 text-[11px] font-black uppercase tracking-widest animate-pulse" data-id="element-120">
            🔥 OFERTA SOLO POR HOY — DESPUÉS SUBE DE PRECIO 🔥
          </div>

          <div className="p-5 md:p-8" data-id="element-121">
            {/* Items incluidos */}
            <div className="space-y-2 mb-4" data-id="element-122">
              {[{
              icon: '📚',
              name: '6 Tomos PDF paso a paso',
              value: '$53.400'
            }, {
              icon: '🎁',
              name: '4 Bonos Exclusivos',
              value: '$30.600'
            }, {
              icon: '♾️',
              name: 'Acceso inmediato y de por vida',
              value: ''
            }].map((item, i) => <div key={i} className="flex items-center justify-between bg-gray-900/50 rounded-lg px-4 py-3 border border-gray-700/50" data-id="element-123">
                  <div className="flex items-center gap-2.5" data-id="element-124">
                    <CheckCircle2 className="w-4 h-4 text-blue-500 flex-shrink-0" data-id="element-125" />
                    <span className="text-gray-200 text-sm font-medium" data-id="element-126">
                      <span className="mr-1.5" data-id="element-127">{item.icon}</span>
                      {item.name}
                    </span>
                  </div>
                  {item.value && <span className="text-gray-500 line-through text-xs font-medium flex-shrink-0 ml-3" data-id="element-128">
                      {item.value}
                    </span>}
                </div>)}
            </div>

            {/* Total tachado */}
            <div className="flex justify-between items-center bg-gray-950/80 px-4 py-3 rounded-lg border border-gray-800 mb-5" data-id="element-129">
              <span className="text-gray-400 font-bold text-xs uppercase tracking-wider" data-id="element-130">
                Valor Real
              </span>
              <span className="text-red-400/80 font-black text-base line-through" data-id="element-131">
                $83.900 ARS
              </span>
            </div>

            {/* Precio */}
            <div className="text-center mb-5 relative" data-id="element-132">
              <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-40 h-40 bg-blue-500/15 rounded-full blur-2xl pointer-events-none" data-id="element-133" />
              <p className="text-blue-400 text-[11px] font-black uppercase tracking-widest mb-2 relative z-10" data-id="element-134">
                SOLO POR HOY PAGÁS:
              </p>
              <div className="flex items-start justify-center gap-1 relative z-10" data-id="element-135">
                <span className="text-gray-400 text-lg font-bold mt-2" data-id="element-136">$</span>
                <p className="text-6xl md:text-7xl font-black text-white tracking-tighter leading-none" data-id="element-137">
                  19.990
                </p>
              </div>
              <div className="flex items-center justify-center gap-3 mt-2 relative z-10" data-id="element-138">
                <span className="text-gray-400 text-xs font-bold" data-id="element-139">ARS</span>
                <span className="bg-green-500/20 text-green-400 px-2.5 py-0.5 rounded-full text-[11px] font-black border border-green-500/30" data-id="element-140">
                  AHORRÁS +80%
                </span>
              </div>
            </div>

            {/* Alerts compactos */}
            <div className="flex flex-col md:flex-row gap-2 mb-5" data-id="element-141">
              <div className="flex-1 bg-blue-500/10 border border-blue-500/20 rounded-lg px-3 py-2.5 flex items-center gap-2" data-id="element-142">
                <span data-id="element-143">💰</span>
                <p className="text-blue-300 text-[12px] font-medium" data-id="element-144">
                  Lo recuperás con el primer arreglo.
                </p>
              </div>
              <div className="flex-1 bg-amber-500/10 border border-amber-500/20 rounded-lg px-3 py-2.5 flex items-center gap-2" data-id="element-145">
                <span data-id="element-146">⏳</span>
                <p className="text-amber-400 text-[12px] font-bold" data-id="element-147">
                  Mañana vuelve al precio original.
                </p>
              </div>
            </div>

            {/* CTA */}
            <CTAButton href={CHECKOUT_URL} text="⚡ COMPRÁ AHORA — ACCESO INMEDIATO" subtext="🔒 Compra protegida por MercadoPago — Descarga al instante" data-id="element-148" />

            {/* Garantía */}
            <div className="flex items-center justify-center gap-2 mt-4 mb-4" data-id="element-149">
              <ShieldCheckIcon className="w-4 h-4 text-green-400 flex-shrink-0" data-id="element-150" />
              <p className="text-gray-400 text-[11px] font-medium" data-id="element-151">
                Garantía de devolución total a 30 días. Sin preguntas.
              </p>
            </div>

            {/* Trust signals inline */}
            <div className="grid grid-cols-4 gap-1 pt-4 border-t border-gray-700/50" data-id="element-152">
              {[{
              icon: ZapIcon,
              label: 'Inmediato',
              color: 'text-blue-400'
            }, {
              icon: DownloadIcon,
              label: 'Digital',
              color: 'text-blue-400'
            }, {
              icon: InfinityIcon,
              label: 'De por vida',
              color: 'text-blue-400'
            }, {
              icon: ShieldCheckIcon,
              label: 'Garantía',
              color: 'text-green-400'
            }].map((item, i) => <div key={i} className="flex flex-col items-center gap-1.5 text-gray-400" data-id="element-153">
                  <item.icon className={`w-4 h-4 ${item.color}`} data-id="element-154" />
                  <span className="text-[9px] font-bold uppercase tracking-wider" data-id="element-155">
                    {item.label}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
});